module.exports = __webpack_public_path__ + "static/media/recommendedb.c45205cd.png";